import { Inject } from '@odinjs/odin';

import { Endpoint, ToastService, TokenUtils } from '@philips-emr/hpms-provider-commons';
import { HPMSOnCloseModalAbout } from '@philips-emr/hpms-provider-components';
import { LinkAPI, PanelAPI, TextAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService, ModalService } from '@philips-emr/tws-core/lib/services';
import { ModalProps } from '@philips-emr/tws-core/lib/services/modal-service';
import { format } from '@philips-emr/tws-core/lib/services/model-service';
import { getBreakpoint, isEmptyOrBlankString } from '@philips-emr/tws-utils';

import { MyDataAliases as Aliases, FragmentNames } from '../codegen';
import { Route } from '../route';

import BaseController from './BaseController';

interface User {
  id: string;
  name: string;
  cdPhysicalPerson: string;
  dsEmail: string;
  dtLastAccess: string;
}

@Controller({ fragment: FragmentNames.MY_DATA })
export default class MyDataController extends BaseController {

  @Inject(Aliases.TEXT_LAST_ACCESS)
  private lastAccessText!: TextAPI;

  @Inject(Aliases.PANEL_ABOUT)
  private panelAbout: PanelAPI;

  @OnClick(Aliases.LINK_PRIVACY)
  onClickPrivacy(): void {
    this.historyService.push(Route.PRIVACY);
  }

  @OnClick(Aliases.LINK_CHANGE_PW)
  onClickChangePassoword(): void {
    HttpService.get<User>(Endpoint.GET.MY_DATA_USER)
      .then(({ body: user }) => {
        if (user && !isEmptyOrBlankString(user.id)) {
          this.showRenewPasswordModal(+user.id);
        }
      }).catch(() => ToastService.open({ level: ToastLevel.ERROR, message: MessageService.translate('provider.general-error') }));
  }

  @OnMount(Aliases.LINK_CHANGE_PW)
  onMountLinkPassword(event: MountEvent): void {
    const api = event.target as LinkAPI;
    const { ssoLogin } = TokenUtils.getValues();
    if (ssoLogin == 'S') {
      api.setValue('');
      api.setEnabled(false);
    }
  }

  @OnMount(Aliases.PANEL_LAST_ACCESS)
  public onMountPanelLastAccess(event: MountEvent): void {
    const api = event.target as unknown as PanelAPI;
    const setVisibility = (visibility: boolean): void => api.setVisible(visibility);

    void HttpService.get<User>(Endpoint.GET.MY_DATA_USER)
      .then(({ body: user }) => {
        let visibility = false;

        if (user && !isEmptyOrBlankString(user.dtLastAccess)) {
          visibility = true;

          const message = MessageService.translate('provider.hello-user-last-access')
            .replace('#@NM_USUARIO#@', user.name)
            .replace('#@DT_ULTIMO_ACESSO#@', format('date', user.dtLastAccess, { type: 'timestamp' }));

          this.lastAccessText.setValue(message);
        } else if (user) {
          visibility = true;
          const message = `${MessageService.translate('provider.hello')} ${user.name}. ${MessageService.translate('provider.welcome-first-access')}`;
          this.lastAccessText.setValue(message);
        }

        setVisibility(visibility);
      }).catch(() => setVisibility(false));
  }

  @OnClick(Aliases.LINK_ABOUT)
  onClickAbout(): void {
    this.panelAbout.setVisible(true);
  }

  @HPMSOnCloseModalAbout(Aliases.HPMS_ABOUT)
  onCloseAbout(): void {
    this.panelAbout.setVisible(false);
  }

  showRenewPasswordModal(nrSeqWSuiteUser: number): void {
    const modalWithFragment: ModalProps = {
      closeable: true,
      fragment: FragmentNames.CHANGE_PW,
      contextData: { nrSeqWSuiteUser },
      id: 'renew-password',
    };
    const breakpoints = getBreakpoint() as string;
    if (breakpoints == 'sm' || breakpoints == 'xsm') {
      ModalService.openFullscreen(modalWithFragment);
    } else {
      ModalService.openDialog(modalWithFragment);
    }
  }
}
